import 'rc-time-picker/assets/index.css';

import React, { Component } from 'react';

import Upload from './upload';

class WidgetUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: [],
      multiple:
        props.schema.multiple !== undefined ? props.schema.multiple : false,
      title:
        props.schema.title !== undefined ? props.schema.title : 'Subir archivo',
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.formData !== undefined && nextProps.formData !== '') {
      this.setState({
        value: nextProps.formData,
      });
    } else {
      value: [];
    }
  }

  onChange = (files) => {
    var newFiles = JSON.parse(JSON.stringify(files));
    this.props.onChange(newFiles);
  };

  render() {
    return (
      <Upload
        label={this.state.title}
        multiple={this.state.multiple}
        onChange={this.onChange.bind(this)}
        files={this.state.value}
      />
    );
  }
}

export default WidgetUpload;



// WEBPACK FOOTER //
// ./src/lib/field-upload.js